
  import { defineComponent, onMounted, ref } from 'vue';
  import { setCurrentPageBreadcrumbs } from '@/core/helpers/breadcrumb';
  import { useI18n } from 'vue-i18n/index';
  import { useStore } from 'vuex';
  import { Actions } from '@/store/enums/StoreEnums';
  import { useRoute, useRouter } from 'vue-router';
  import { useAbility } from '@casl/vue';

  export default defineComponent({
    name: 'promotion-history',
    setup() {
      const { t, te } = useI18n();
      const store = useStore();
      const route = useRoute();
      const router = useRouter();
      const { can } = useAbility();

      const promo = ref<any | null>(null);
      const employees = ref<any[]>([]);
      const employeeCount = ref<number>(0);

      const currentPage = ref(1);
      const pageSize = ref(10);
      const totalItems = ref(0);
      const isNext = ref(false);

      const translate = (text: string, options: any = {}) =>
        te(text) ? t(text, options) : text;

      const promoId = ref<number>(Number(route.params.id));

      const fetchPromoHistory = async () => {
        const { data } = await store.dispatch(
          Actions.GET_PROMO_HISTORY,
          promoId.value
        );
        promo.value = data?.promo ?? data?.data ?? data;
      };

      const fetchPromoUsers = async () => {
        const data = await store.dispatch(Actions.GET_PROMO_USERS, {
          id: promoId.value,
          page: currentPage.value,
          pageSize: pageSize.value,
        });

        employees.value = data.data ?? [];
        employeeCount.value = data.totalItems ?? 0;
        currentPage.value = data.currentPage ?? currentPage.value;
        pageSize.value = data.pageSize ?? pageSize.value;
        totalItems.value = data.totalItems ?? 0;
        isNext.value = Boolean(data.isNext);
      };

      const onPageChange = async (direction: 'next' | 'previous') => {
        if (direction === 'next' && isNext.value) currentPage.value += 1;
        if (direction === 'previous' && currentPage.value > 1)
          currentPage.value -= 1;
        await fetchPromoUsers();
      };

      onMounted(async () => {
        setCurrentPageBreadcrumbs(translate('promotionHistory'), [
          translate('promotions'),
        ]);
        await fetchPromoHistory();
        await fetchPromoUsers();
      });

      const goBack = () => router.back();

      store.dispatch(Actions.REMOVE_BODY_CLASSNAME, 'page-loading-over');

      return {
        can,
        translate,
        promo,
        employees,
        employeeCount,
        currentPage,
        pageSize,
        totalItems,
        isNext,
        onPageChange,
        goBack,
      };
    },
  });
